import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import UploadBlankSlate from '../../_partials/UploadBlankSlate';

const DraftsBlankSlate: FC<{}> = () => {
  const { t } = useTranslation();
  return (
    <UploadBlankSlate
      title={t('studio.blankSlate.dropzone.drafts.title')}
      subtitle={t('studio.blankSlate.dropzone.drafts.subtitle')}
      ctaLabel={t('studio.blankSlate.dropzone.drafts.ctaLabel')}
    />
  );
};
DraftsBlankSlate.displayName = 'DraftsBlankSlate';

export default DraftsBlankSlate;
